import React from 'react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const baseFeatures = [{
    text: 'Tomo 1 — El Año Resuelto',
    included: true
  }, {
    text: 'Tomo 2 — Pequeños Pianistas',
    included: true
  }, {
    text: 'Tomo 3 — Teoría que se Juega',
    included: true
  }, {
    text: 'Tomo 4 — Repertorio Listo',
    included: true
  }, {
    text: 'Tomo 5 — Manos que Vuelan',
    included: true
  }, {
    text: 'Tomo 6 — El Gran Concierto',
    included: true
  }, {
    text: 'Bonos Premium (6 recursos extras)',
    included: false
  }, {
    text: 'Partituras de Películas Famosas',
    included: false
  }, {
    text: 'Manual de Supervivencia',
    included: false
  }, {
    text: 'Diccionario del Piano',
    included: false
  }, {
    text: 'Marca Personal',
    included: false
  }, {
    text: 'Cómo Cobrar lo que Vales',
    included: false
  }, {
    text: 'Instagram para Profes',
    included: false
  }];
  const premiumFeatures = ['Los 6 Tomos completos', '🎁 BONO 1 — Partituras de Películas Famosas (valor $12.000)', '🎁 BONO 2 — Manual de Supervivencia del Profesor (valor $10.000)', '🎁 BONO 3 — Diccionario del Piano: 200 Términos (valor $11.000)', '🎁 BONO 4 — Tu Marca Personal como Profesor (valor $9.000)', '🎁 BONO 5 — Cómo Cobrar lo que Vales (valor $10.000)', '🎁 BONO 6 — Instagram y Redes para Profes (valor $9.000)', 'Acceso de por vida a actualizaciones', 'Acceso prioritario a nuevos contenidos'];
  return <section id="pricing" className="bg-navy-900 bg-grain py-24 relative" data-id="element-165">
      <div className="container mx-auto px-6 content-relative" data-id="element-166">
        <FadeIn className="text-center mb-16" data-id="element-167">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-4" data-id="element-168">
            Elegí tu MegaPack Piano Listo:
          </h2>
          <p className="font-accent italic text-xl md:text-2xl text-gold" data-id="element-169">
            Las dos opciones incluyen los 6 tomos completos
          </p>
        </FadeIn>

        <div className="flex flex-col lg:flex-row items-center lg:items-stretch justify-center gap-8 max-w-6xl mx-auto" data-id="element-170">
          {/* BASE PACK */}
          <FadeIn delay={0.1} direction="right" className="w-full lg:w-[40%] max-w-md" data-id="element-171">
            <div className="bg-cream rounded-2xl p-8 border border-gray-300 h-full flex flex-col mt-0 lg:mt-8" data-id="element-172">
              <div className="text-center mb-6" data-id="element-173">
                <div className="text-4xl mb-4" data-id="element-174">📘</div>
                <h3 className="font-bold text-xl text-navy-900 mb-1" data-id="element-175">
                  MEGAPACK PIANO LISTO
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-176">
                  6 tomos · Sistema completo
                </p>
              </div>

              <div className="text-center mb-8" data-id="element-177">
                <p className="text-gray-500 line-through font-sans text-base mb-1" data-id="element-178">
                  $34.900 ARS
                </p>
                <p className="font-sans font-extrabold text-3xl md:text-4xl text-navy-900 tracking-tight" data-id="element-179">
                  $18.980 <span className="text-lg md:text-xl" data-id="element-180">ARS</span>
                </p>
              </div>

              <div className="space-y-3 mb-8 flex-grow" data-id="element-181">
                {baseFeatures.map((feat, i) => <div key={i} className={`flex items-start gap-3 text-sm ${feat.included ? 'text-navy-800' : 'text-gray-400'}`} data-id="element-182">
                    <span className="shrink-0 mt-0.5" data-id="element-183">
                      {feat.included ? '✅' : '❌'}
                    </span>
                    <span data-id="element-184">{feat.text}</span>
                  </div>)}
              </div>

              <a href="https://checkout.totaliadigital.com/cart/53693904585072:1" className="w-full bg-navy-800 hover:bg-navy-700 text-white font-bold py-4 rounded-lg transition-colors block text-center" data-id="element-185">
                → QUIERO EL MEGAPACK BASE
              </a>
            </div>
          </FadeIn>

          {/* PREMIUM PACK (DOMINANT) */}
          <FadeIn delay={0.2} direction="left" className="w-full lg:w-[50%] max-w-lg relative z-10" data-id="element-186">
            <div className="absolute -inset-1 bg-gradient-to-r from-gold-dark via-gold-light to-gold-dark rounded-2xl blur opacity-50 animate-pulse-slow" data-id="element-187"></div>
            <div className="bg-warmWhite rounded-2xl p-1 border-2 border-gold relative h-full flex flex-col shadow-[0_0_40px_rgba(212,180,100,0.3)] transform lg:-translate-y-4" data-id="element-188">
              <div className="bg-gradient-to-r from-navy-800 to-navy-900 text-gold text-center py-2 rounded-t-xl font-bold text-sm tracking-widest uppercase" data-id="element-189">
                ⭐ MÁS ELEGIDO · AHORRÁS $32.020
              </div>

              <div className="p-8 flex flex-col h-full" data-id="element-190">
                <div className="text-center mb-6" data-id="element-191">
                  <div className="text-5xl mb-4" data-id="element-192">🏆</div>
                  <h3 className="font-display font-bold text-2xl text-navy-900 mb-1" data-id="element-193">
                    MEGAPACK PIANO LISTO PREMIUM
                  </h3>
                  <p className="text-gray-600 font-medium" data-id="element-194">
                    6 tomos + 6 bonos exclusivos
                  </p>
                </div>

                <div className="text-center mb-8" data-id="element-195">
                  <p className="text-gray-500 line-through font-sans text-lg mb-0" data-id="element-196">
                    $59.910 ARS
                  </p>
                  <p className="text-xs text-gray-400 mb-2" data-id="element-197">
                    (Si comprás todo por separado)
                  </p>
                  <p className="font-sans font-extrabold text-5xl md:text-6xl text-gold-dark mb-3 tracking-tight" data-id="element-198">
                    $27.890 <span className="text-2xl md:text-3xl" data-id="element-199">ARS</span>
                  </p>
                  <span className="inline-block bg-success/10 text-success border border-success/30 px-4 py-1 rounded-full font-bold text-sm" data-id="element-200">
                    💰 AHORRÁS $32.020 (53% OFF)
                  </span>
                </div>

                <div className="space-y-4 mb-10 flex-grow bg-white/50 p-6 rounded-xl border border-gold/10" data-id="element-201">
                  {premiumFeatures.map((feat, i) => <div key={i} className="flex items-start gap-3 text-navy-900 font-medium text-sm" data-id="element-202">
                      <span className="text-success shrink-0 mt-0.5" data-id="element-203">✅</span>
                      <span data-id="element-204">{feat}</span>
                    </div>)}
                </div>

                <div className="mt-auto" data-id="element-205">
                  <a href="https://checkout.totaliadigital.com/cart/53693910516080:1" className="w-full bg-gradient-to-r from-gold to-gold-dark hover:from-gold-light hover:to-gold text-navy-900 font-bold text-lg py-5 rounded-xl shadow-[0_0_20px_rgba(212,180,100,0.4)] transition-all transform hover:-translate-y-1 mb-4 block text-center" data-id="element-206">
                    → SÍ, QUIERO EL PIANO LISTO PREMIUM
                  </a>
                  <p className="text-center text-xs text-gray-500 mb-6 px-4" data-id="element-207">
                    La opción más elegida por profes que quieren
                    profesionalizarse y cobrar lo que merecen
                  </p>

                  <div className="flex flex-wrap justify-center items-center gap-3 text-xs text-gray-500 font-medium" data-id="element-208">
                    <span className="flex items-center gap-1" data-id="element-209">
                      🔒 Pago seguro
                    </span>
                    <span data-id="element-210">·</span>
                    <span className="flex items-center gap-1" data-id="element-211">
                      ⚡ Acceso en 5 min
                    </span>
                    <span data-id="element-212">·</span>
                    <span className="flex items-center gap-1" data-id="element-213">
                      🛡️ Garantía 7 días
                    </span>
                    <span data-id="element-214">·</span>
                    <span className="flex items-center gap-1" data-id="element-215">
                      💳 Mercado Pago
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}